import React from 'react';
import { BsTwitter, BsInstagram} from "react-icons/bs";
import {FaGithub, FaLinkedinIn} from "react-icons/fa"; 

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <a href='https://www.linkedin.com/in/abdul-chaman-sk/'><FaLinkedinIn></FaLinkedinIn></a>
        </div>
        <div>
            <a href='https://github.com/abdulchaman'><FaGithub></FaGithub></a>
        </div>
        <div>
            <BsInstagram></BsInstagram>
        </div>
    </div>
  )
}

export default SocialMedia